import React, { useState, useEffect } from "react";
import styled from "styled-components";
import useMeasure from "react-use-measure";
import { useSpring, animated } from "react-spring";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";

import "./mainNavBar.scss";

const HamburgerMenu = styled(animated.div)`
  overflow: hidden;
`;

const Navigation = ({ isView, applicationId }) => {
  // console.log(isView, applicationId);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [UserData, setUserData] = useState({});
  const [navbar, setNavbar] = useState(false);
  const [ref, bounds] = useMeasure();
  const [cookies, setCookie, removeCookie] = useCookies(["accept-cookies"]);

  const panelCOntentAnimatedStyle = useSpring({
    height: isCollapsed ? 0 : bounds.height,
  });

  const handleClick = () => {
    const menu = document.querySelector(".hamburger-menu");
    menu.classList.toggle("active");
    setIsCollapsed((prevState) => !prevState);
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const sectionOffset =
        document.querySelector("section:first-of-type").offsetTop * 0.8;
      if (currentScrollPos >= sectionOffset) {
        setNavbar(true);
      } else {
        setNavbar(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const checkResize = () => {
    const hamburger = document.querySelector(".hamburger");
    const menu = document.querySelector(".menu");
    if (!menu || !hamburger) {
      return;
    }
    if (window.innerWidth > 768) {
      menu.classList.add("active");
      hamburger.style.display = "none";
      setIsCollapsed(true);
    } else {
      menu.classList.remove("active");
      hamburger.style.display = "block";
    }
  };

  useEffect(() => {
    checkResize();
    window.addEventListener("resize", checkResize);
  }, []);

  useEffect(() => {
    fetch("./login.php", {
      // credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        localStorage.setItem("isLogged", data.logged);
        localStorage.setItem("isAdmin", data.admin);
        setUserData(data);
        // console.log(data);
      });
  }, []);

  let navigate = useNavigate();

  const routeChange = () => {
    let path = `/`;
    navigate(path);
  };

  function handleBlacklist(id) {
    const reason = window.prompt("Wprowadź powód blacklisty:");

    const data = new FormData();
    data.append("id", id);
    data.append("reason", reason);

    fetch(`./blacklistApplication.php`, {
      method: "POST",
      // credentials: "include",
      body: data,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "ok") {
          alert("Dziwna sytuacja wygląda że wszystko poszło dobrze");
        } else if (data.status == "addedBefore") {
          alert(
            "Wygląda na to że osoba była dodana do blacklist już wcześniej"
          );
        } else if (data.status == "error") {
          alert(
            "Coś poszło nie tak spróbuj ponownie późnij lub zgłoś się do administracji"
          );
        }
        // console.log(data);
      })
      .catch((error) => console.error(error));
  }

  function handleAccept(id) {
    fetch(`./acceptApplication.php?id=${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "ok") {
          alert("Dziwna sytuacja wygląda że wszystko poszło dobrze");
        } else if (data.status == "addedBefore") {
          alert("Wygląda na to że osoba była dodana do WL już wcześniej");
        } else if (data.status == "error") {
          alert(
            "Coś poszło nie tak spróbuj ponownie późnij lub zgłoś się do administracji"
          );
        }
        // console.log(data);
      })
      .catch((error) => console.error(error));
  }

  function handleReject(id) {
    const reason = window.prompt("Podaj dodatkowe informacje:");

    if (reason === null) {
      return; 
    }

    const data = new FormData();
    data.append("id", id);
    data.append("reason", reason);

    fetch(`./rejectApplication.php`, {
      method: "POST",
      body: data,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "ok") {
          alert("Dziwna sytuacja wygląda że wszystko poszło dobrze");
        } else if (data.status == "error") {
          alert(
            "Coś poszło nie tak spróbuj ponownie późnij lub zgłoś się do administracji"
          );
        }
        // console.log(data);
      })
      .catch((error) => console.error(error));
  }

  function handleVerification(id) {
    const reason = window.prompt("Podaj dodatkowe informacje:");

    if (reason === null) {
      return; 
    }

    const data = new FormData();
    data.append("id", id);
    data.append("reason", reason);

    fetch(`./verificationApplication.php`, {
      method: "POST",
      body: data,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "ok") {
          alert("Dziwna sytuacja wygląda że wszystko poszło dobrze");
        } else if (data.status == "error") {
          alert(
            "Coś poszło nie tak spróbuj ponownie późnij lub zgłoś się do administracji"
          );
        }
        // console.log(data);
      })
      .catch((error) => console.error(error));
  }

  return (
    <React.Fragment>
      <div className={navbar ? "navigation active" : "navigation"}>
        <div className="logo" onClick={routeChange}></div>

        <div className="menu active">
          {UserData.logged == true &&
          isView == true &&
          UserData.admin == true ? (
            <React.Fragment>
              {UserData.rank >= 3 ? (
                <a onClick={() => handleBlacklist(applicationId)}>BLACKLIST</a>
              ) : null}
              <a onClick={() => handleAccept(applicationId)}>PRZYJMIJ</a>
              <a onClick={() => handleReject(applicationId)}>ODRZUĆ</a>
              <a onClick={() => handleVerification(applicationId)}>
                WERYFIKACJA
              </a>
            </React.Fragment>
          ) : null}

          <a href="https://discord.gg/pcShtURP9V">Discord</a>
          <a href="#/rules">Regulamin</a>

          {UserData.logged == true ? (
            UserData.admin == true ? (
              <a href="#/panel">Panel</a>
            ) : (
              <a href="#/application">Aplikacja</a>
            )
          ) : null}

          <a href="#">Pobierz</a>

          {/* {UserData.logged == true ? (
                        <a>{UserData.personaname}</a>
                    ) : (null)} */}

          {cookies["accept-cookies"] ? (
            UserData.logged == true ? (
              <a href="./steamauth/steamauth.php?logout">Wyloguj</a>
            ) : (
              <a href="./steamauth/steamauth.php?login">Zaloguj</a>
            )
          ) : null}

          {UserData.logged == true ? (
            <a>
              <img src={UserData.avatar}></img>
            </a>
          ) : null}
        </div>

        <div className="hamburger" onClick={() => handleClick()}>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </div>
      <HamburgerMenu
        className="hamburger-menu"
        style={panelCOntentAnimatedStyle}
      >
        <div className="hamburger-menu-items" ref={ref}>
          {UserData.logged == true &&
          isView == true &&
          UserData.admin == true ? (
            <React.Fragment>
              {UserData.rank >= 3 ? (
                <a onClick={() => handleBlacklist(applicationId)}>BLACKLIST</a>
              ) : null}
              <a onClick={() => handleAccept(applicationId)}>PRZYJMIJ</a>
              <a onClick={() => handleReject(applicationId)}>ODRZUĆ</a>
              <a onClick={() => handleVerification(applicationId)}>
                WERYFIKACJA
              </a>
            </React.Fragment>
          ) : null}

          <a href="https://discord.gg/pcShtURP9V">Discord</a>
          <a href="#/rules">Regulamin</a>

          {UserData.logged == true ? (
            UserData.admin == true ? (
              <a href="#/panel">Panel</a>
            ) : (
              <a href="#/application">Aplikacja</a>
            )
          ) : null}

          <a href="#">Pobierz</a>

          {UserData.logged == true ? <a>{UserData.personaname}</a> : null}

          {UserData.logged == true ? (
            <a>
              <img src={UserData.avatar}></img>
            </a>
          ) : null}

          {cookies["accept-cookies"] ? (
            UserData.logged == true ? (
              <a href="./steamauth/steamauth.php?logout">Wyloguj</a>
            ) : (
              <a href="./steamauth/steamauth.php?login">Zaloguj</a>
            )
          ) : null}
        </div>
      </HamburgerMenu>
    </React.Fragment>
  );
};

export default Navigation;
